(function () {
  'use strict';

  var oldLabel = "Options d'achat";
  var newLabel = 'Votre rythme de commande';
  var widgetSelector = '#appstle_subscription_widget0';

  function renameLabel(widget) {
    if (!widget) return;
    var walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === oldLabel) {
        node.nodeValue = node.nodeValue.replace(oldLabel, newLabel);
      }
    }
  }

  function connect() {
    var widget = document.querySelector(widgetSelector);
    if (!widget) return false;

    renameLabel(widget);
    var widgetObserver = new MutationObserver(function () {
      renameLabel(widget);
    });
    widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      widgetObserver.disconnect();
    }, 10000);
    return true;
  }

  if (connect()) return;

  var pageObserver = new MutationObserver(function () {
    if (connect()) pageObserver.disconnect();
  });
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    pageObserver.disconnect();
  }, 10000);
})();
